import { useState } from "react";
import axios from "axios";
import { API_BASE } from "../lib/api";
import { toast } from "sonner";

export const FIELD =
  "w-full rounded-2xl border border-navy/15 bg-cream px-4 py-3 text-sm text-navy placeholder:text-slate-400 outline-none transition-colors focus:border-gold focus:bg-white";

export function useSimpleForm(initial, endpoint, { success, error }) {
  const [form, setForm] = useState(initial);
  const [loading, setLoading] = useState(false);

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
      await axios.post(`${API_BASE}${endpoint}`, form);
      toast.success(success);
      setForm(initial);
    } catch {
      toast.error(error);
    } finally {
      setLoading(false);
    }
  };

  return { form, setForm, set, submit, loading };
}
